// src/mocks/handlers/funding/commissionsDownloadAllHandler.ts

import { rest } from 'msw';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { genericResponse } from '@/shared/types/api';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';

export const fundingCommissionsDownloadAllHandler = rest.get<genericResponse>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.FUNDING_COMMISSIONS_DOWNLOAD_ALL}`,
  (req, res, ctx) => {
    const token = req.headers.get('Authorization');
    if (!token) {
      return res(ctx.status(500), ctx.json({ detail: 'Something went wrong' }));
    }

    if (isAccessTokenExpired()) {
      return res(ctx.status(401), ctx.json({ error: 'Access token expired' }));
    }

    return res(
      ctx.status(200),
      ctx.json({ message: 'The file will be sent to your email.' }),
    );
  },
);
